import { render, staticRenderFns } from "./TransferRender.vue?vue&type=template&id=7589f896&functional=true"
import script from "./TransferRender.vue?vue&type=script&lang=js"
export * from "./TransferRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports